import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
// import fonts from '../../constants/fonts'

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  min-height: 102px;
  width: 100vw;
  background-color: ${(props) => (props.screen === "landing" ? "transparent" : "#f5a462")};
  padding: 0 10% 0 0;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: ${breakpoints.desktop.pixels}) {
    padding: 0 5% 0 0;
  }
  @media screen and (max-width: 600px) {
    flex-direction: ${(props) => (props.screen === "form" ? "row" : "column")};
    align-items: center;
    padding: 16px 5% 16px 0;
  }

  & > section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    & > img {
      width: 100%;
      height: 100%;
      transform: scale(0.7);
    }
  }

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    @media screen and (max-width: 600px) {
      margin: 8px 0;
    }
    & > button:first-of-type {
      background-color: #e86f51;
      height: 32px;
      white-space: nowrap;
      border-radius: 25px;
      outline: none;
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: row;
      color: white;
      border: none;
      cursor: pointer;
      margin: 0 16px 0 0;
      font-size: 15px;
      @media screen and (max-width: 600px) {
        height: 24px;
      };
      &:hover {
        text-decoration: underline;
      }
    }
    & > button:last-of-type {
      border: none;
      cursor: pointer;
      outline: none;
      color: white;
      background-color: ${(props) => (props.screen === "form" ? "#E8C468" : "transparent")};
      font-size: 15px;
      @media screen and (max-width: 600px) {
        height: 24px;
      };
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
